import React from "react";

import classes from "./LeftBar.module.css";

const LeftBar = (props) => {
  return (
    <div className={classes.LeftBar}>
      <button
        className={
          props.postMode === "published" ? classes.Chosed : classes.Btn
        }
        type="button"
        onClick={(event) => {
          props.postModeHandler("published");
        }}
      >
        published
      </button>
      <button
        className={props.postMode === "reviewed" ? classes.Chosed : classes.Btn}
        type="button"
        onClick={(event) => {
          props.postModeHandler("reviewed");
        }}
      >
        reviewed
      </button>
      <button
        className={props.postMode === "onHold" ? classes.Chosed : classes.Btn}
        type="button"
        onClick={(event) => {
          props.postModeHandler("onHold");
        }}
      >
        on hold
      </button>
      <button
        className={props.postMode === "draft" ? classes.Chosed : classes.Btn}
        type="button"
        onClick={(event) => {
          props.postModeHandler("draft");
        }}
      >
        draft
      </button>
    </div>
  );
};

export default LeftBar;
